import fakedb from "../fakedb.json";
import advise from "../views/Payments";
/**
 * Created by Federico Brocco on 13/05/2022.
 *
 * @format
 */

/**
 * Recupera l'elenco degli avvisi di pagamento per l'utente autenticato
 * @returns {Promise<Array>} Promise che risolve con un array di avvisi di pagamento
 */
let list = function () {
    return new Promise(function (resolve, reject) {
        const hash = localStorage.getItem('hash');

        if (hash === null) {
            reject("NO_AUTH");
            return;
        }

        fetch(window.route.payments, {
            headers: {'x-access-token': hash},
            method: 'GET'
        })
            .then((response) => (response.status !== 500) ? response.json() : reject())
            .then((responseJson) => {
                console.log('API payments_notice', responseJson.payments_notice);
                resolve(responseJson.payments_notice);
            })
            .catch((e) => {
                console.error(e.message);
                reject()
            });
    });
};

/**
 * Recupera i dettagli di un avviso di pagamento specifico
 * @param {string|number} payments_notice_id - L'ID dell'avviso di pagamento
 * @returns {Promise<Array>} Promise che risolve con i dettagli dei pagamenti
 */
let detail = function (payments_notice_id) {
    return new Promise(function (resolve, reject) {
        const hash = localStorage.getItem('hash');

        if (hash === null) {
            reject("NO_AUTH");
            return;
        }

        fetch(window.route.paymentsDetail + "?payment_notice_id=" + payments_notice_id, {
            headers: {'x-access-token': hash},
            method: 'GET'
        })
            .then((response) => (response.status !== 500) ? response.json() : reject())
            .then((responseJson) => {
                console.log('API payments_notice_detail', responseJson);
                resolve(responseJson.payments);
            })
            .catch((e) => {
                console.error(e.message);
                reject  ()
            });
    });
};

// PaymentsAPI.openIuv({payments_notice_id:row.payments_notice_id});
/**
 * Apre un IUV (Identificativo Univoco di Versamento) per un avviso di pagamento
 * @param {Object} row - L'oggetto contenente i dati dell'avviso di pagamento
 * @param {string|number} row.payments_notice_id - L'ID dell'avviso di pagamento
 * @returns {Promise<Object>} Promise che risolve con i dati dell'IUV aperto
 */
let openIuv= function (row) {//console.log('here');console.log(row.payments_notice_id);
    return new Promise(function (resolve, reject) {
        const hash = localStorage.getItem('hash');
        if (hash === null) {
            reject("NO_AUTH");
            return;
        }

        fetch(window.route.bookingIuv, {
            headers: {'x-access-token': hash},
            method: 'POST',
            body: JSON.stringify({
                payments_notice_id: row.payments_notice_id
            })
        })
            .then((response) => (response.status !== 500) ? response.json() : reject())
            .then((responseJson) => {
                console.log('API openIuv', responseJson);
                resolve(responseJson);
            })
            .catch((e) => {
                console.error(e.message);
                reject()
            });
    });
};

// pagoPA Checkout vuole l'importo come intero in centesimi di euro (102,00 € -> 10200)
const PAGOPA_AMOUNT_MULTIPLIER = 100;

/**
 * Crea un carrello su pagoPA Checkout per una rata e restituisce l'URL di pagamento
 * I dati dell'ente creditore (codice fiscale e ragione sociale) arrivano dal comune
 * caricato con l'API homepage (window.municipalityData).
 * @param {Object} row - La rata (elemento di `iuvs`) da pagare
 * @param {string} row.codice_avviso - Codice avviso (18 cifre)
 * @param {number} row.total - Importo dell'avviso in euro
 * @param {string} [description] - Causale (descrizione della pendenza)
 * @returns {Promise<string>} Promise che risolve con l'URL della pagina di pagamento pagoPA
 */
let checkoutPagoPA = function (row, description) {
    return new Promise(function (resolve, reject) {
        const returnUrl = window.location.href;
        const municipality = window.municipalityData || {};
        const body = {
            paymentNotices: [{
                noticeNumber: row.codice_avviso,
                fiscalCode: municipality.codice_fiscale,
                amount: Math.round(row.total * PAGOPA_AMOUNT_MULTIPLIER),
                companyName: municipality.name,
                description: (description || 'Pagamento avviso ' + row.codice_avviso).substring(0, 140)
            }],
            returnUrls: {
                returnOkUrl: returnUrl,
                returnCancelUrl: returnUrl,
                returnErrorUrl: returnUrl,
                returnWaitingUrl: returnUrl
            }
        };

        console.log('API checkoutPagoPA request', JSON.stringify(body, null, 2));

        fetch(window.route.pagoPACheckoutCarts, {
            headers: {'Content-Type': 'application/json'},
            method: 'POST',
            body: JSON.stringify(body)
        })
            .then((response) => response.text().then((text) => {
                if (!response.ok) {
                    console.error('API checkoutPagoPA', response.status, text, JSON.stringify(body, null, 2));
                    reject(response.status);
                    return;
                }
                // La risposta è HTML con un meta refresh verso il checkout:
                // <meta http-equiv="refresh" content="0; URL=https://checkout.pagopa.it/c/...?clientId=CHECKOUT_CART" />
                const match = text.match(/URL=([^"'\s>]+)/i);
                const url = match ? match[1].replace(/&amp;/g, '&') : (response.redirected ? response.url : null);
                console.log('API checkoutPagoPA', url);
                url ? resolve(url) : reject('NO_URL');
            }))
            .catch((e) => {
                console.error(e.message);
                reject();
            });
    });
};

const paymentsAPI = {
    list: list,
    detail: detail,
    openIuv: openIuv,
    checkoutPagoPA: checkoutPagoPA
};

export default paymentsAPI;
